module.exports = __webpack_public_path__ + "static/media/free-coffee-mobile-en.ed07378d.jpg";